const chartOpacity = 0.5;

export function truncateFloat(number) {
    let dec = 2;
    let newNum;
    if(number === 0) {
        return number;
    }
    do {
        newNum = Number((number*100).toFixed(dec));
        dec += 1;
    }
    while (newNum === 0)
    return newNum;
}

export function generateRandomColor(colorsUsed, opacity) {
    let color;
    let red;
    let green;
    let blue;
    if(!opacity) {
        opacity = chartOpacity
    }
    do {
        red = Math.floor((Math.random()) * 200);
        green = Math.floor((Math.random()) * 200);
        blue = Math.floor((Math.random()) * 200);
        color = `rgba(${red}, ${green}, ${blue}, ${opacity})`
    } while(colorsUsed.includes(color));
    return color;
}

export function generateRandomColorPair(colorsUsed, opacity) {
    let lightColor;
    let boldColor;
    let red;
    let green;
    let blue;
    if(!opacity) {
        opacity = chartOpacity
    }
    do {
        red = Math.floor((Math.random()) * 200);
        green = Math.floor((Math.random()) * 200);
        blue = Math.floor((Math.random()) * 200);
        lightColor = `rgba(${red}, ${green}, ${blue}, ${opacity})`
    } while(colorsUsed.includes(lightColor));
    boldColor = `rgba(${red}, ${green}, ${blue}, 0.4)`
    return {lightColor, boldColor};
}

export function generateErrorColor(grade) {
    let red = 190;
    let green = 100;
    let blue = 50
    if(grade === 0) {
        red = 156;
        green = 200;
    }
    else {
        red = 211;
        green = 235 - Math.floor(grade) * 40
        green = green >= 0 ? green : 0
        blue = 7;
    }
    return `rgba(${red}, ${green}, ${blue}, 0.5)`
}

export function normalizeToRange(array, tmin, tmax) {
  let normalizedArray = [];
  if(array.length === 1) {
      return([tmax]);
  }
  let rmin = Math.min(...array);
  let rmax = Math.max(...array);
  array.map(value => {
    let newVal;
    if(rmax === rmin) {
        newVal = tmax/2;
    } else {
        newVal = (value - rmin)/(rmax - rmin) * (tmax-tmin) + tmin;
    }
    return normalizedArray.push(newVal);
  });
  return normalizedArray;
}

export function normalizeSeverity(severity, maxSeverity) {
  return Math.floor((6-1) * (severity  - 1)/ (maxSeverity - 1) + 1)
}

export function capitalizeEachWord(str) {
    let words = str.toLowerCase().split(' ');
    let skipWords = ['και'];
    let newWords = words.map(word => {
        let t = skipWords.indexOf(word) < 0 ? word.charAt(0).toUpperCase() + word.substr(1) : word
        return t;
    })
    let newString = newWords.reduce((acc, cur) => 
        acc = `${acc} ${cur}`
    , '');
    return newString;
}

export function removeSpecialChars(str) {
    str = str.toUpperCase();
    str = str.replace(new RegExp("Ά", "g"), "Α");
    str = str.replace(new RegExp("Έ", "g"), "Ε");
    str = str.replace(new RegExp("Ό", "g"), "Ο");
    str = str.replace(new RegExp("Ή", "g"), "Η");
    str = str.replace(new RegExp("Ύ", "g"), "Υ");
    str = str.replace(new RegExp("Ί", "g"), "Ι");
    str = str.replace(new RegExp("Ώ", "g"), "Ω");   
    return str;
}



// WEBPACK FOOTER //
// ./src/lib/helpers.js